import React from 'react';
import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Input,
  Paper,
  TextField,
  Grid,
  InputLabel,
  makeStyles,
} from '@material-ui/core';
import moment from 'moment';


export const SuccessPayment = ({ appointmentData, goToVideo }) => {
  const useStyles = makeStyles((theme) => ({
    formControl: {
      fontFamily: theme.typography.fontFamily,
      marginBottom: '2rem',
      width: '100%',
    },
    H5: {
      fontFamily: theme.typography.fontFamily,
      textAlign: 'center',
      marginBottom: '2rem',
      fontSize: 23,
      color: '#4a4a4a;',
    },
    H4: {
      fontFamily: theme.typography.fontFamily,
      fontSize: '14px',
      color: '#4a4a4a',
      lineHeight: 2,
    },
    SPAN: {
      textAlign: 'center',
      marginBottom: '1rem',
      fontSize: '14.4px',
      color: '#4a4a4a',
    },
    register: {
      marginTop: '1rem',
      border: `2px solid ${theme.palette.primary.main}`,
      '&:hover, &:focus': {
        border: `2px solid ${theme.palette.primary.main}`,
      },
    },
    label: {
      color: theme.palette.primary.main,
      fontSize: '0.7rem',
    },
    modalBody: {
      padding: '2rem',
      overflow: 'auto',
    },
    helpText: {
      fontFamily: theme.typography.fontFamily,
      textAlign: 'center',
      marginTop: '2rem',
      fontStyle: 'italic',
      fontSize: '14px',
    },
  }));
  const classes = useStyles();

  return (
    <Grid
      container
      justify="center"
      alignItems="center"
      direction="column"
      style={{
        minHeight: '100vh',
        backgroundColor: '#f1f1f1',
      }}
    >
      <Grid item style={{ minWidth: '30%', minHeight: '30%' }} xs={11} md={3}>
        <Paper elevation={3}>
          <Box
            p={'10%'}
            display="flex"
            flexDirection="column"
            alignItems="center"
          >
            <Box className={classes.H5}>Pago exitoso!</Box>
            <p className={classes.formControl}>
              <strong>Consulta agendada:</strong> Usted tiene una consulta
              agendada para la fecha{' '}
              <strong>{appointmentData && `${moment(appointmentData.date).format('YYYY-MM-DD HH:mm')}`}</strong>, puede acceder a la
              misma haciendo click en el siguiente boton en la fecha indicada.
            </p>
            <Button
              variant="contained"
              color="primary"
              type="submit"
              style={{ width: '50%' }}
              onClick={goToVideo}
              //   onClick={() => goToVideo(code)}
            >
              Ir a video consulta
            </Button>
          </Box>
        </Paper>
      </Grid>
    </Grid>
  );
};
